/**
 * Recommended image dimensions for every upload field in the dashboard.
 * Keep these in sync with the design specs so hints stay accurate everywhere.
 */
export interface ImageSize {
  width: number;
  height: number;
}

export const IMAGE_SIZES = {
  banner: { width: 1200, height: 600 },
  serviceIcon: { width: 165, height: 165 },
  productMain: { width: 1080, height: 660 },
  productGallery: { width: 315, height: 285 },
  profile: { width: 360, height: 360 },
  labCategoryIcon: { width: 192, height: 192 },
  onboarding: { width: 1170, height: 2532 },
} as const satisfies Record<string, ImageSize>;
